import { lazy, Suspense } from 'react';
import { Outlet } from 'react-router-dom';

import { Layout as SettingLayout } from 'src/layouts/setting';

const IndexPage = lazy(() => import('src/pages/dashboard/index'));
const ContactPage = lazy(() => import('src/pages/dashboard/contact'));
// Country
const CountryListPage = lazy(() => import('src/pages/setting/country/countryList'));
const CountryCreatePage = lazy(() => import('src/pages/setting/country/createCountry'));

const UserListPage = lazy(() => import('src/pages/setting/user/userList'));
const UserCreatePage = lazy(() => import('src/pages/setting/user/createUser'));


const RegionListPage = lazy(() => import('src/pages/setting/region/regionList'));
const RegionCreatePage = lazy(() => import('src/pages/setting/region/createRegion'));

const TaxListPage = lazy(() => import('src/pages/setting/tax/taxList'));
const TaxCreatePage = lazy(() => import('src/pages/setting/tax/createTax'));

const StoreListPage = lazy(() => import('src/pages/setting/store/storeList'));
const StoreCreatePage = lazy(() => import('src/pages/setting/store/createStore'));

const ExpensesTypeListPage = lazy(() => import('src/pages/setting/expensesType/expensesTypeList'));
const ExpensesTypeCreatePage = lazy(() => import('src/pages/setting/expensesType/createExpensesType'));

const ReceivedTypeListPage = lazy(() => import('src/pages/setting/receivedType/receivedTypeList'));
const ReceivedTypeCreatePage = lazy(() => import('src/pages/setting/receivedType/createReceivedType'));

const LoyaltyPointListPage = lazy(() => import('src/pages/setting/loyaltyPoint/loyaltyPointList'));
const LoyaltyPointCreatePage = lazy(() => import('src/pages/setting/loyaltyPoint/createLoyaltyPoint'));

const DiscountListPage = lazy(() => import('src/pages/setting/discount/discountList'));
const DiscountCreatePage = lazy(() => import('src/pages/setting/discount/createDiscount'));

const RoleTypesListPage = lazy(() => import('src/pages/setting/roleTypes/roleTypesList'));
const RoleTypesCreatePage = lazy(() => import('src/pages/setting/roleTypes/createRoleTypes'));

const RolesListPage = lazy(() => import('src/pages/setting/roles/rolesList'));
const RolesCreatePage = lazy(() => import('src/pages/setting/roles/createRoles'));

const LocationListPage = lazy(() => import('src/pages/setting/location/locationList'));
const LocationCreatePage = lazy(() => import('src/pages/setting/location/createLocation'));

const PaymentTypeListPage = lazy(() => import('src/pages/setting/paymentType/paymentTypeList'));
const PaymentTypeCreatePage = lazy(() => import('src/pages/setting/paymentType/createPaymentType'));

const GiftCardListPage = lazy(() => import('src/pages/setting/giftCard/giftCardList'));
const GiftCardCreatePage = lazy(() => import('src/pages/setting/giftCard/createGiftCard'));

// Invoice
const InvoiceListPage = lazy(() => import('src/pages/setting/invoices/list'));
const InvoiceDetailPage = lazy(() => import('src/pages/setting/invoices/detail'));

// Order
const OrderListPage = lazy(() => import('src/pages/setting/orders/list'));
const OrderDetailPage = lazy(() => import('src/pages/setting/orders/detail'));

const SysMenuListPage = lazy(() => import('src/pages/setting/sysMenu/sysMenuList'));
const SysMenuCreatePage = lazy(() => import('src/pages/setting/sysMenu/createSysMenu'));

const SysTransListPage = lazy(() => import('src/pages/setting/sysTranslate.js/translateList'));
const SysTransCreatePage = lazy(() => import('src/pages/setting/sysTranslate.js/createTranslate'));

const ProfilePage = lazy(() => import('src/pages/setting/profile/profilePage'));
const ChangePasswordPage = lazy(() => import('src/pages/setting/profile/changePasswordPage'));

export const settingRoutes = [
  {
    path: 'setting',
    element: (
      <SettingLayout>
        <Suspense>
          <Outlet />
        </Suspense>
      </SettingLayout>
    ),
    children: [
      {
        index: true,
        element: <IndexPage />
      },
      {
        path: 'profile',
        element: <ProfilePage />
      },
      {
        path: 'change-password',
        element: <ChangePasswordPage />
      },
      {
        path: 'sysMenu',
        children: [
          {
            index: true,
            element: <SysMenuListPage />
          },
          {
            path: 'createSysMenu',
            element: <SysMenuCreatePage />
          }
        ]
      },
      {
        path: 'sysTranslate',
        children: [
          {
            index: true,
            element: <SysTransListPage />
          },
          {
            path: 'createTranslate',
            element: <SysTransCreatePage />
          }
        ]
      },
      {
        path: 'user',
        children: [
          {
            index: true,
            element: <UserListPage />
          },
          {
            path: 'createUser',
            element: <UserCreatePage />
          }
        ]
      },
      {
        path: 'country',
        children: [
          {
            index: true,
            element: <CountryListPage />
          },
          {
            path: 'createCountry',
            element: <CountryCreatePage />
          }
        ]
      },
      {
        path: 'region',
        children: [
          {
            index: true,
            element: <RegionListPage />
          },
          {
            path: 'createRegion',
            element: <RegionCreatePage />
          }
        ]
      },
      {
        path: 'tax',
        children: [
          {
            index: true,
            element: <TaxListPage />
          },
          {
            path: 'createTax',
            element: <TaxCreatePage />
          }
        ]
      },
      {
        path: 'store',
        children: [
          {
            index: true,
            element: <StoreListPage />
          },
          {
            path: 'createStore',
            element: <StoreCreatePage />
          }
        ]
      },
      {
        path: 'location',
        children: [
          {
            index: true,
            element: <LocationListPage />
          },
          {
            path: 'createLocation',
            element: <LocationCreatePage />
          }
        ]
      },
      {
        path: 'paymentType',
        children: [
          {
            index: true,
            element: <PaymentTypeListPage />
          },
          {
            path: 'createPaymentType',
            element: <PaymentTypeCreatePage />
          }
        ]
      },
      {
        path: 'expensesType',
        children: [
          {
            index: true,
            element: <ExpensesTypeListPage />
          },
          {
            path: 'createExpensesType',
            element: <ExpensesTypeCreatePage />
          }
        ]
      },
      {
        path: 'receivedType',
        children: [
          {
            index: true,
            element: <ReceivedTypeListPage />
          },
          {
            path: 'createReceivedType',
            element: <ReceivedTypeCreatePage />
          }
        ]
      },
      {
        path: 'loyaltyPoint',
        children: [
          {
            index: true,
            element: <LoyaltyPointListPage />
          },
          {
            path: 'createLoyaltyPoint',
            element: <LoyaltyPointCreatePage />
          }
        ]
      },
      {
        path: 'giftCard',
        children: [
          {
            index: true,
            element: <GiftCardListPage />
          },
          {
            path: 'createGiftCard',
            element: <GiftCardCreatePage />
          }
        ]
      },
      {
        path: 'discount',
        children: [
          {
            index: true,
            element: <DiscountListPage />
          },
          {
            path: 'createDiscount',
            element: <DiscountCreatePage />
          }
        ]
      },
      {
        path: 'roleTypes',
        children: [
          {
            index: true,
            element: <RoleTypesListPage />
          },
          {
            path: 'createRoleTypes',
            element: <RoleTypesCreatePage />
          }
        ]
      },
      {
        path: 'roles',
        children: [
          {
            index: true,
            element: <RolesListPage />
          },
          {
            path: 'createRoles',
            element: <RolesCreatePage />
          }
        ]
      },
      {
        path: 'invoices',
        children: [
          {
            index: true,
            element: <InvoiceListPage />
          },
          {
            path: ':invoiceId',
            element: <InvoiceDetailPage />
          }
        ]
      },
      {
        path: 'orders',
        children: [
          {
            index: true,
            element: <OrderListPage />
          },
          {
            path: ':orderId',
            element: <OrderDetailPage />
          }
        ]
      },
      {
        path: 'contact',
        element: <ContactPage />
      },
    ],
  },

];
